import { useService } from '@visiba/instantiation';
import { AnalyticAction } from '@application/analytic/analytic.service';
import { VisibaLink } from '@components/visiba-link.component';
import { LicenceHolderService } from '@services/licence_holder.service';
import { getAbsoluteRoute } from '@helpers/route';
import { AspectRatio } from '@cellula/react';
import { useCurrentLocation } from '@src/application/use_current_location';
import { FeatureFlagService } from '@services/feature_flag/feature_flag.service';

interface Props {
	locationName?: string;
	__TEMP__navigate?(url: string): void;
	trackEvent?: (action: AnalyticAction) => void;
	logoUrl?: string;
	size?: 'small' | 'medium' | 'large';
}

export function Logo({ trackEvent, __TEMP__navigate, logoUrl, locationName, size = 'medium' }: Props): JSX.Element {
	const licenceHolderService = useService(LicenceHolderService);
	const featureFlagService = useService(FeatureFlagService);
	const [_, config] = useCurrentLocation();

	let width: number;
	switch (size) {
		case 'small':
			width = 48;
			break;
		case 'medium':
			width = 96;
			break;
		case 'large':
			width = 128;
			break;
	}

	const customerLogo = logoUrl ?? (config?.theme.EmailLogoUrl as string | undefined);

	const logotype = (
		<div
			style={{
				width: width,
			}}
		>
			<AspectRatio.Root ratio={2}>
				{customerLogo ? (
					<img
						src={customerLogo}
						alt=''
						style={{
							objectFit: 'contain',
							width: '100%',
							height: '100%',
							borderRadius: 'var(--radius-2)',
						}}
					/>
				) : (
					<span>{locationName}</span>
				)}
			</AspectRatio.Root>
		</div>
	);

	if (featureFlagService.checkFlag('PatientWeb.ClickableLogotype')) {
		function handleClick(): void {
			trackEvent?.('Clicked: Logo');
		}

		return (
			<VisibaLink
				tabIndex={-1}
				onClick={handleClick}
				to={`/${getAbsoluteRoute(licenceHolderService.alias)}`}
				__TEMP__to={`/${licenceHolderService.alias}`}
				__TEMP__navigate={__TEMP__navigate}
			>
				{logotype}
			</VisibaLink>
		);
	}

	function handleClickStaticLogo(): void {
		trackEvent?.('Clicked: Logo without link');
	}

	return <div onClick={handleClickStaticLogo}>{logotype}</div>;
}
